import { cloneElement } from 'react';
import { Stack, Theme } from '@mui/material';
import { Typography } from '../typography';

interface BannerProps {
  message: React.ReactNode;
  Icon: React.ReactElement;
  color: 'grayBlue' | 'orange' | 'error';
}

const COLOR_MAP = {
  grayBlue: {
    bgColor: ({ palette }: Theme) => palette.grayBlue?.[100],
    color: ({ palette }: Theme) => palette.grayBlue?.main,
  },
  orange: {
    bgColor: ({ palette }: Theme) => palette.orange?.[100],
    color: ({ palette }: Theme) => palette.orange?.[600],
  },
  error: {
    bgColor: ({ palette }: Theme) => palette.error?.[50],
    color: ({ palette }: Theme) => palette.error?.[600],
  },
};

export const Banner = ({ message, Icon, color }: BannerProps) => (
  <Stack
    direction="row"
    alignItems="flex-start"
    bgcolor={COLOR_MAP[color].bgColor}
    borderRadius={2}
    px={4}
    py={3}
    minHeight={48}
    gap={2}
    color={COLOR_MAP[color].color}
  >
    {cloneElement(Icon, { fontSize: 'small', sx: { mt: 0.5 } })}
    <Typography variant="textMd" fontWeight="medium">
      {message}
    </Typography>
  </Stack>
);
